import { i18n } from '@/common/utils/i18n'

export const SIGN_COUNTRY_LIST = [
  {
    label: i18n.gettext('墨西哥'),
    value: 'MX'
  }
]
export const SIGN_PARTY_TYPE_LIST = [
  {
    label: i18n.gettext('普通商家'),
    value: 1
  },
  {
    label: i18n.gettext('CKA'),
    value: 2
  },
  {
    label: i18n.gettext('KA'),
    value: 3
  }
]

export const SIGN_PARTY_TYPE_NORMAL_OPTIIN = {
  label: i18n.gettext('普通商家'),
  value: 1
}

export const SIGN_PARTY_TYPE_CKA_OPTIIN = {
  label: i18n.gettext('CKA'),
  value: 2
}

export const SIGN_PARTY_TYPE_KA_OPTIIN = {
  label: i18n.gettext('KA'),
  value: 3
}

export const SIGN_PARTY_TYPE_MAP = {
  1: i18n.gettext('普通商家'),
  2: i18n.gettext('CKA'),
  3: i18n.gettext('KA')
}

export const SIGN_DELIVERY_TYPE_LIST = [
  {
    label: i18n.gettext('支持'),
    value: 1
  },
  {
    label: i18n.gettext('不支持'),
    value: 2
  }
]

export const SIGN_PARTYA_TITLE_LIST = [
  {
    value: 1,
    text: i18n.gettext('合法代表')
  },
  {
    value: 2,
    text: i18n.gettext('董事')
  },
  {
    value: 3,
    text: i18n.gettext('授权人')
  },
  {
    value: 4,
    text: i18n.gettext('其他')
  }
]

export const ACCOUNT_TYPE_LIST = [
  {
    value: 1,
    text: i18n.gettext('对公')
  },
  {
    value: 2,
    text: i18n.gettext('对私')
  }
]

export const ACCOUNT_CARD_TYPE_LIST = [
  {
    value: 1,
    text: i18n.gettext('活期')
  },
  {
    value: 2,
    text: i18n.gettext('储蓄')
  }
]
export const ACCOUNT_BANK_LIST = [
  { 'key': '1', 'value': 'Banco do Brasil S.A.' },
  { 'key': '33', 'value': 'Banco Santander (Brasil) S.A.' },
  { 'key': '104', 'value': 'Caixa Econômica Federal' },
  { 'key': '237', 'value': 'Banco Bradesco S.A.' },
  { 'key': '341', 'value': 'Itaú Unibanco S.A.' },
  { 'key': '3', 'value': 'Banco da Amazônia S.A.' },
  { 'key': '4', 'value': 'Banco do Nordeste do Brasil S.A.' },
  { 'key': '21', 'value': 'BANESTES S.A. Banco do Estado do Espírito Santo' },
  { 'key': '41', 'value': 'Banco do Estado do Rio Grande do Sul S.A.' },
  { 'key': '70', 'value': 'BRB - Banco de Brasília S.A.' },
  { 'key': '77', 'value': 'BANCO INTER' },
  { 'key': '84', 'value': 'Unicred Norte Do Parana' },
  { 'key': '85', 'value': 'Cooperativa Central de Crédito Urbano-CECRED' },
  { 'key': '121', 'value': 'BANCO AGIPLAN S.A.' },
  { 'key': '136', 'value': 'Unicred do Brasil S.A.' },
  { 'key': '212', 'value': 'BANCO ORIGINAL' },
  { 'key': '246', 'value': 'Banco ABC Brasil S.A.' },
  { 'key': '260', 'value': 'NU PAGAMENTOS' },
  { 'key': '290', 'value': 'PagSeguro Internet S.A' },
  { 'key': '318', 'value': 'BANCO BMG S.A.' },
  { 'key': '336', 'value': 'Banco C6 S.A.' },
  { 'key': '389', 'value': 'Banco Mercantil do Brasil S.A.' },
  { 'key': '399', 'value': 'HSBC Bank Brasil S.A. - Banco Múltiplo' },
  { 'key': '422', 'value': 'Banco Safra S.A.' },
  { 'key': '623', 'value': 'Banco Panamericano S.A.' },
  { 'key': '637', 'value': 'BANCO SOFISA' },
  { 'key': '748', 'value': 'Banco Cooperativo Sicredi S.A.' },
  { 'key': '218', 'value': 'BANCO BONSUCESSO S.A.' },
  { 'key': '477', 'value': 'CITIBANK N.A.' },
  { 'key': '745', 'value': 'BANCO CITIBANK' },
  { 'key': '756', 'value': 'BANCO COOPERATIVO DO BRASIL S/A - BANCOOB' },
  { 'key': '707', 'value': 'BANCO DAYCOVAL S.A.' },
  { 'key': '037', 'value': 'BANCO DO ESTADO DO PARA S.A. - BANPARA' },
  { 'key': '047', 'value': 'BANCO DO ESTADO DE SERGIPE S.A. - BANESE' },
  { 'key': '746', 'value': 'BANCO MODAL S.A.' }
]
export const SIGN_AUTHORIZATION_TYPE_LIST = [
  {
    value: 1,
    text: i18n.gettext('签约授权书')
  },
  {
    value: 2,
    label: i18n.gettext('打款授权书')
  },
  {
    value: 3,
    label: i18n.gettext('品牌授权书')
  }
]

export const SIGN_CONTRACT_TEMPLATE_TYPE_LIST = [
  {
    value: 1,
    label: i18n.gettext('标准合同模板')
  }
]

export const SIGN_SHOP_STATUS_MAP = {
  0: i18n.gettext('信息未完善'),
  1: i18n.gettext('信息已完善')
}
export const SIGN_SHOP_STATUS_TYPE_MAP = {
  0: 'warning',
  1: 'success'
}

export const SIGN_PACK_AUDIT_STATUS_MAP = {
  1: i18n.gettext('审核中'),
  2: i18n.gettext('审核失败'),
  3: i18n.gettext('审核完成')
}
export const SIGN_PACK_AUDIT_STATUS_TYPE_MAP = {
  1: 'warning',
  2: 'danger',
  3: 'success'
}

export const SIGN_AUDIT_STATUS_MAP = {
  2: i18n.gettext('审核中'),
  3: i18n.gettext('审核失败'),
  4: i18n.gettext('审核完成'),
  5: i18n.gettext('审核通过')
}

export const SIGI_DISABLED_STATUS_LIST = [2, 4, 5]

export const SIGN_AUDIT_STATUS_TYPE_MAP = {
  1: 'info',
  2: 'warning',
  3: 'danger',
  4: 'success',
  5: 'success'
}

export const SIGN_PACK_TO_TAB_MAP = {
  soda_restaurant: 'basic',
  soda_restaurant_license: 'qualification',
  soda_restaurant_contract: 'contract',
  soda_restaurant_legal: 'contract'
}

export const SIGN_CONTRACT_TYPE_LIST = [
  {
    value: 1,
    text: i18n.gettext('标准合同模板')
  }
]

export const SIGN_CONTRACT_VERSION_MAP = {
  1: '1.0'
}

export const SIGN_CONTRACTOR_TYPE_LIST = [
  {
    value: 1,
    text: i18n.gettext('股份有限公司')
  },
  {
    value: 2,
    text: i18n.gettext('有限责任公司')
  },
  {
    value: 3,
    text: i18n.gettext('个人')
  },
  {
    value: 4,
    text: i18n.gettext('个人企业')
  }
]

export const SIGN_PACK_DRAFT_STATUS_MAP = {
  UNSAVED: 1,
  SAVED: 2
}

export const PACK_NUM_1 = 'soda_restaurant'
export const PACK_NUM_2 = 'soda_restaurant_license'
export const PACK_NUM_3 = 'soda_restaurant_contract'
export const PACK_NUM_4 = 'soda_restaurant_legal'

export const PACK_NUM_1_KEYS = ['name', 'logo']
export const PACK_NUM_2_KEYS = [
  // 'resName',
  // 'resAddr',
  // 'licenseNum',
  // 'scope',
  // 'openDate',
  // 'validateDate',
  'licensePics'
]
export const PACK_NUM_3_KEYS = [
  'contractNo',
  'partyaName',
  // 'partyaRegisteAddr',
  'partyaEmail',
  'partyaContact',
  'partyaPhone',
  'accountHolder',
  'accountAddr',
  'accountCardno',
  // accountBankName
  // 'financeChief',
  // 'financePhone',
  // 'financeEmail',
  'oneselfType',
  'platformType',
  'oneselfRate',
  'platformRate'
]
export const PACK_NUM_4_KEYS = ['legalName', 'legalType', 'legalId', 'legalPics', 'legalExtra']

export const CATEGORY_MAP = {
  1: ['basic'],
  2: ['qualification'],
  3: ['contract'],
  4: ['contractorOther', 'shopOther', 'other']
}

// 启动费金额 梯度
export const STARTUP_MONEY_SELECT_LIST_CONFIG = [
  {
    text: '0',
    value: 0
  },
  {
    text: '100',
    value: 10000
  },
  {
    text: '200',
    value: 20000
  },
  {
    text: '300',
    value: 30000
  },
  {
    text: '400',
    value: 40000
  },
  {
    text: '500',
    value: 50000
  },
  {
    text: '600',
    value: 60000
  },
  {
    text: '700',
    value: 70000
  }
]

// 设备信息： 是否需要pad
export const EQUIPMENT_INFO_PAD_SELECT_LIST = [
  {
    text: i18n.gettext('需要'),
    value: 1
  },
  {
    text: i18n.gettext('不需要'),
    value: 0
  }
]

// 默认合同版本 1.0
export const DEFAULT_CONTRACT_VERSOIN = '1.0'
